
const loading = {
    namespaced: true,
    state: () => ({
        loading: false,
        loading_btn: false,
        textLoading: 'Carregando aguarde',
        loading_id: '',
    }),
    mutations: {
        status(state, status) {
            state.loading = status;
        },
        statusBtn(state, status) {
            state.loading_btn = status;

        },
        setLoadId(state, id) {
            state.loading_id = id;
        }

    },

}


export default loading;